import { Routes } from '@angular/router';
import { AuthGuard } from '@ov-suite/authguard-angular';
import { FeatureKey } from '@ov-suite/helpers-shared/lib/feature.enum';
import { InventoryHeldByUserListComponent } from './list/inventory-held-by-user-list.component';

export const InventoryHeldByUserRoutes: Routes = [
  {
    path: '',
    children: [
      {
        data: { feature: { id: FeatureKey.INVENTORY_PRODUCT } },
        canActivate: [AuthGuard],
        path: '',
        component: InventoryHeldByUserListComponent,
      },
    ],
  },
];
